import {useContext, useEffect, useState} from 'react';
import InputMask from 'react-input-mask';
import api from '../../service/api';
import styles from './index.module.css';
import { Link } from 'react-router-dom'
import { Row, Col, Form, FormGroup, Label, Input, Button, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { useFormik } from 'formik';
import NavbarComponent from '../../components/Navbar/NavbarComponent';
import NavMenuComponent from '../../components/NavMenu/NavMenuComponent';
import ModalComponent from '../../components/Modal/ModalComponent';
import {Context as AuthContext} from "../../context/authContext";

function CadastroVida() {
    const [isRegister, setIsRegister] = useState(false);
    const [errorRegister, setErrorRegister] = useState("");
    const { userRole } = useContext(AuthContext);
    const isAdmin = userRole === "admin";
    const parceiroIdLogado = localStorage.getItem("parceiroId");
    const [listaParceiros, setListaParceiros] = useState([]);
    useEffect(() => {
        if (isAdmin) {
            api.get('parceiro').then(res => setListaParceiros(res.data));
        }
    }, [isAdmin]);

    const generos = [
        "Cisgênero",
        "Transgênero",
        "Não-binário",
        "Outro",
        "Não se aplica"];
    const estadosCivis = [
        "Solteiro",
        "Casado",
        "Separado",
        "Divorciado",
        "Viúvo"];
    const validaCPF = (cpf) => {
        cpf = cpf.replace(/\./g, '');
        cpf = cpf.replace('-', '');

        var soma;
        var resto;

        if (cpf.length !== 11 ||
            cpf === "00000000000" ||
            cpf === "11111111111" ||
            cpf === "22222222222" ||
            cpf === "33333333333" ||
            cpf === "44444444444" ||
            cpf === "55555555555" ||
            cpf === "66666666666" ||
            cpf === "77777777777" ||
            cpf === "88888888888" ||
            cpf === "99999999999") {
            return false;
        }

        //Validacao do primeiro digito do CPF
        soma = 0;
        for (let i = 1; i <= 9; i++) {
            soma = soma + parseInt(cpf.substring(i - 1, i)) * (11 - i);
        }
        resto = (soma * 10) % 11;

        if ((resto === 10) || (resto === 11)) {
            resto = 0;
        }

        if (resto !== parseInt(cpf.substring(9, 10))) {
            return false;
        }

        //Validacao do segundo digito do CPF
        soma = 0;
        for (let i = 1; i <= 10; i++) {
            soma = soma + parseInt(cpf.substring(i - 1, i)) * (12 - i);
        }
        resto = (soma * 10) % 11;

        if ((resto === 10) || (resto === 11)) {
            resto = 0;
        }

        if (resto !== parseInt(cpf.substring(10, 11))) {
            return false;
        }

        return true
    }

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
        },
        validateOnBlur: true,
        validate: values => {
            const errors = {};

            if (!values.nome) {
                errors.nome = "O campo é obrigatório.";
            } else if (values.nome.length < 3) {
                errors.nome = "O nome deve conter mais de 3 letras.";
            }

            const data_teste = /^(((0[1-9]|[12][0-9]|3[01])\/(0[13578]|10|12)\/(\d{4}))|(([0][1-9]|[12][0-9]|30)\/(0[469]|11)\/(\d{4}))|((0[1-9]|1[0-9]|2[0-8])\/(02)\/(\d{4}))|((29)(\.|-|\/)(02)\/([02468][048]00))|((29)\/(02)\/([13579][26]00))|((29)\/(02)\/([0-9][0-9][0][48]))|((29)\/(02)\/([0-9][0-9][2468][048]))|((29)\/(02)\/([0-9][0-9][13579][26])))$/;
            if (!values.data_nascimento) {
                errors.data_nascimento = "O campo é obrigatório.";
            } else if (!data_teste.test(values.data_nascimento)) {
                errors.data_nascimento = "Digite uma data válida dd/mm/aaaa.";
            }

            if (!values.genero) {
                errors.genero = "O campo é obrigatório.";
            }

            const cpf_teste = /^\d{3}\.\d{3}\.\d{3}-\d{2}$/;
            if (!values.cpf) {
                errors.cpf = "O campo é obrigatório.";
            } else if (!cpf_teste.test(values.cpf)) {
                errors.cpf = "Digite um CPF válido 000.000.000-00.";
            } else if (!validaCPF(values.cpf)) {
                errors.cpf = "Digite um CPF válido 000.000.000-00.";
            }

            if (!values.estado_civil) {
                errors.estado_civil = "O campo é obrigatório.";
            }

            const telefone_teste = /^\((?:[14689][1-9]|2[12478]|3[1234578]|5[1345]|7[134579])\) (?:[2-8]|9[1-9])[0-9]{3}-[0-9]{4}$/;
            if (!values.telefone) {
                errors.telefone = "O campo é obrigatório.";
            } else if (!telefone_teste.test(values.telefone)) {
                errors.telefone = "Digite um telefone válido (99) 99999-9999.";
            }

            const email_teste = /^([a-zA-Z0-9_\-.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})$/;
            if (!values.email) {
                errors.email = "O campo é obrigatório.";
            } else if (!email_teste.test(values.email)) {
                errors.email = "Digite um e-mail válido nome@email.com."
            }

            //validar requisitos mínimos
            const senha_teste = /^(?=.*\d)(?=.*[a-z]|[A-Z])[0-9a-zA-Z$*&@#]{8,}$/;

            if (!values.senha) {
                errors.senha = "O campo é obrigatório.";
            } else if (!senha_teste.test(values.senha)) {
                errors.senha = "A senha deve conter pelo menos 8 caracteres incluindo letras e números.";
            }

            if (!values.confirmar_senha) {
                errors.confirmar_senha = "O campo é obrigatório.";
            } else if (values.confirmar_senha !== values.senha) {
                errors.confirmar_senha = "As senhas não são iguais.";
            }

            return errors;
        },
        onSubmit: (values) => {
            const errors = formik.validateForm(values);

            if (Object.keys(errors).length > 0) {
                formik.setErrors(errors);
                return;
            }

            setErrorRegister("");
            api.post('vida', {
                nome: values.nome,
                nomeSocial: values.nome_social,
                dataNascimento: values.data_nascimento,
                genero: values.genero,
                estadoCivil: values.estado_civil,
                telefone: values.telefone,
                cpf: values.cpf,
                email: values.email,
                senha: values.senha,
                status: 'ativo',
                papel: 3,
                parceiro_id: isAdmin ? values.parceiroId : parceiroIdLogado
            }).then((response) => {
                setIsRegister(true);
            }).catch((error) => {
                if (error.response) {
                    setErrorRegister(error.response.status);
                } //Logs a string: Error: Request failed with status code 404
            });
        }
    });

    return (
        <div className={styles.mainDiv}>
            <NavbarComponent />
            <NavMenuComponent />

            {errorRegister ? (
                <ModalComponent
                    isOpen={true}
                    onClose={() => setErrorRegister("")}
                    mensagem="Não foi possivel concluir o cadastro!"
                    icon="Erro"
                />
            ) : null}
            {isRegister ? (
                <ModalComponent
                    isOpen={true}
                    onClose={() => setIsRegister(false)}
                    mensagem="Vida cadastrado(a) com sucesso"
                    icon="Sucesso"
                    link="vidas"
                />
            ) : null}

            <div className={styles.route}>
                <Link to="/" className={styles.link}> Home </Link> &gt;
                <span> Cadastrar Vida </span>
            </div>

            <div className={styles.title}>
                Cadastrar Vida
            </div>

            <div responsive className={styles.container}>
                <div className={styles.divDadosGerais}>
                    Dados Gerais
                </div>

                <div className={styles.linha} />

                <Form inline onSubmit={formik.handleSubmit}>
                    <Row xs="4">
                        <Col>
                            <FormGroup className="mb-2 me-sm-2 mb-sm-0">
                                <Label for="nome" className={styles.label}>
                                    Nome *
                                </Label>

                                <Input
                                    autoFocus
                                    className={formik.errors.nome ? styles.errorInput : null}
                                    id="nome"
                                    bsSize="sm"
                                    name="nome"
                                    type="text"
                                    onChange={formik.handleChange}
                                    value={formik.values.nome}
                                />

                                {formik.errors.nome ? <div className={styles.errorDiv}>{formik.errors.nome}</div> : null}
                            </FormGroup>
                        </Col>

                        <Col >
                            <FormGroup className="mb-2 me-sm-2 mb-sm-0">
                                <Label for="nome_social" className={styles.label}>
                                    Nome Social
                                </Label>

                                <Input
                                    id="nome_social"
                                    bsSize="sm"
                                    name="nome_social"
                                    type="text"
                                    onChange={formik.handleChange}
                                    value={formik.values.nome_social}
                                />
                            </FormGroup>
                        </Col>

                        <Col >
                            <FormGroup className="mb-2 me-sm-2 mb-sm-0">
                                <Label for="cpf" className={styles.label}>
                                    CPF *
                                </Label>

                                <InputMask
                                    mask="999.999.999-99"
                                    id="cpf"
                                    bsSize="sm"
                                    name="cpf"
                                    className={`${formik.errors.cpf ? styles.errorInput : ''}`}
                                    onChange={formik.handleChange}
                                    value={formik.values.cpf}
                                >
                                    {(inputProps) => <Input {...inputProps} type="text" />}
                                </InputMask>

                                {formik.errors.cpf ? <div className={styles.errorDiv}>{formik.errors.cpf}</div> : null}
                            </FormGroup>
                        </Col>

                        <Col>
                            <FormGroup className="mb-2 me-sm-2 mb-sm-0">
                                <Label for="data_nascimento" className={styles.label}>
                                    Data de Nascimento *
                                </Label>

                                <InputMask
                                    mask="99/99/9999"
                                    id="data_nascimento"
                                    bsSize="sm"
                                    name="data_nascimento"
                                    className={`${formik.errors.data_nascimento ? styles.errorInput : ''}`}
                                    onChange={formik.handleChange}
                                    value={formik.values.data_nascimento}
                                >
                                    {(inputProps) => <Input {...inputProps} type="text" />}
                                </InputMask>

                                {formik.errors.data_nascimento ? <div className={styles.errorDiv}>{formik.errors.data_nascimento}</div> : null}
                            </FormGroup>
                        </Col>

                        <Col >
                            <FormGroup className="mb-2 me-sm-2 mb-sm-0">
                                <Label for="genero" className={styles.label}>
                                    Gênero *
                                </Label>

                                <UncontrolledDropdown className={formik.errors.genero ? styles.errorInput : styles.dropdown} >
                                    <DropdownToggle caret nav className={styles.dropdownToggle}>
                                        {formik.values.genero || "Selecione uma opção"}
                                    </DropdownToggle>

                                    <DropdownMenu>
                                        {generos.map((g, index) => (
                                            <DropdownItem
                                                className={styles.dropdownItem}
                                                id="genero"
                                                bsSize="sm"
                                                name="genero"
                                                value={generos[index]}
                                                onClick={formik.handleChange}>
                                                {g}
                                            </DropdownItem>
                                        ))}
                                    </DropdownMenu>
                                </UncontrolledDropdown>

                                {formik.errors.genero ? <div className={styles.errorDiv}>{formik.errors.genero}</div> : null}
                            </FormGroup>
                        </Col>

                        <Col >
                            <FormGroup className="mb-2 me-sm-2 mb-sm-0">
                                <Label for="genero" className={styles.label}>
                                    Estado Civil *
                                </Label>

                                <UncontrolledDropdown className={formik.errors.estado_civil ? styles.errorInput : styles.dropdown}>
                                    <DropdownToggle caret nav className={styles.dropdownToggle}>
                                        {formik.values.estado_civil || "Selecione uma opção"}
                                    </DropdownToggle>

                                    <DropdownMenu>
                                        {estadosCivis.map((ec, index) => (
                                            <DropdownItem
                                                className={styles.dropdownItem}
                                                id="estado_civil"
                                                bsSize="sm"
                                                name="estado_civil"
                                                value={estadosCivis[index]}
                                                onClick={formik.handleChange}>
                                                {ec}
                                            </DropdownItem>
                                        ))}
                                    </DropdownMenu>
                                </UncontrolledDropdown>

                                {formik.errors.estado_civil ? <div className={styles.errorDiv}>{formik.errors.estado_civil}</div> : null}
                            </FormGroup>
                        </Col>
                        {isAdmin && (
                            <Col>
                                <FormGroup className="mb-2 me-sm-2 mb-sm-0">
                                    <Label for="parceiroId" className={styles.label}>
                                        Parceiro *
                                    </Label>
                                    <Input
                                        type="select"
                                        id="parceiroId"
                                        name="parceiroId"
                                        bsSize="sm"
                                        className={`${styles.inputPadrao} ${formik.errors.parceiroId ? styles.errorInput : ''}`}
                                        onChange={formik.handleChange}
                                        value={formik.values.parceiroId || ''}
                                    >
                                    <option value="">Selecione o parceiro</option>
                                        {listaParceiros.map(parceiro => (
                                            <option key={parceiro.parceiro_id} value={parceiro.parceiro_id}>
                                                {parceiro.parceiro_nome}
                                            </option>
                                        ))}
                                    </Input>
                                    {formik.errors.parceiroId && <div className={styles.errorDiv}>{formik.errors.parceiroId}</div>}
                                </FormGroup>
                            </Col>
                        )}
                    </Row>

                    <div className={styles.divContato}>
                        Contato
                    </div>

                    <div className={styles.linha} />
                    
                    <Row xs="4">
                        <Col >
                            <FormGroup className="mb-2 me-sm-2 mb-sm-0">
                                <Label for="email" className={styles.label}>
                                    E-mail *
                                </Label>

                                <Input
                                    className={formik.errors.email ? styles.errorInput : null}
                                    id="email"
                                    bsSize="sm"
                                    name="email"
                                    type="email"
                                    onChange={formik.handleChange}
                                    value={formik.values.email}
                                />

                                {formik.errors.email ? <div className={styles.errorDiv}>{formik.errors.email}</div> : null}
                            </FormGroup>
                        </Col>

                        <Col >
                            <FormGroup className="mb-2 me-sm-2 mb-sm-0">
                                <Label for="telefone" className={styles.label}>
                                    Telefone *
                                </Label>

                                <InputMask
                                    mask="(99) 99999-9999"
                                    id="telefone"
                                    bsSize="sm"
                                    name="telefone"
                                    className={`${formik.errors.telefone ? styles.errorInput : ''}`}
                                    onChange={formik.handleChange}
                                    value={formik.values.telefone}
                                >
                                    {(inputProps) => <Input {...inputProps} type="text" />}
                                </InputMask>

                                {formik.errors.telefone ? <div className={styles.errorDiv}>{formik.errors.telefone}</div> : null}
                            </FormGroup>
                        </Col>

                        <Col >
                            <FormGroup className="mb-2 me-sm-2 mb-sm-0">
                                <Label for="senha" className={styles.label}>
                                    Senha *
                                </Label>

                                <Input
                                    className={formik.errors.senha ? styles.errorInput : null}
                                    id="senha"
                                    bsSize="sm"
                                    name="senha"
                                    type="password"
                                    onChange={formik.handleChange}
                                    value={formik.values.senha}
                                />

                                {formik.errors.senha ? <div className={styles.errorDiv}>{formik.errors.senha}</div> : null}
                            </FormGroup>
                        </Col>

                        <Col >
                            <FormGroup className="mb-2 me-sm-2 mb-sm-0">
                                <Label for="confirmar_senha" className={styles.label}>
                                    Confirmar senha *
                                </Label>

                                <Input
                                    className={formik.errors.confirmar_senha ? styles.errorInput : null}
                                    id="confirmar_senha"
                                    bsSize="sm"
                                    name="confirmar_senha"
                                    type="password"
                                    onChange={formik.handleChange}
                                    value={formik.values.confirmar_senha}
                                />

                                {formik.errors.confirmar_senha ? <div className={styles.errorDiv}>{formik.errors.confirmar_senha}</div> : null}
                            </FormGroup>
                        </Col>
                    </Row>

                    <div className={styles.divButton}>
                        <Link to='/home'><Button size="sm" className={styles.buttonCacelar}>Cancelar</Button></Link>
                        <Button size="sm" type="submit" className={styles.buttonCadastrar}  disabled={!(formik.isValid && formik.dirty)}>Cadastrar</Button>
                    </div>
                </Form>
            </div>
        </div>
    );
}

export default CadastroVida;
